import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '../pipes/pipes.module';
import { ModalContentComponent } from './modal-content/modal-content.component';
import { BrandingComponent } from './branding/branding.component';
import { ChartBarsComponent } from './chart-bars/chart-bars.component';
import { ChartGaugeComponent } from './chart-gauge/chart-gauge.component';
import { ChartLineComponent } from './chart-line/chart-line.component';
import { LogoBriviaComponent } from './logo-brivia/logo-brivia.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ],
  declarations: [
    BrandingComponent,
    ChartBarsComponent,
    ChartGaugeComponent,
    ChartLineComponent,
    LogoBriviaComponent,
    ModalContentComponent
  ],
  exports: [
    BrandingComponent,
    ChartBarsComponent,
    ChartGaugeComponent,
    ChartLineComponent,
    LogoBriviaComponent,
    ModalContentComponent
  ]
})
export class ComponentsModule { }
